require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-131-teamgantt-integration-for-slack.json") })
        }
      }, "path---article-131-teamgantt-integration-for-slack");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-131-teamgantt-integration-for-slack!./.cache/json/article-131-teamgantt-integration-for-slack.json
// module id = 485
// module chunks = 231608221292675